import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { format } from 'date-fns';
import classNames from 'classnames';

import ReviewResponse from './ReviewResponse';

import Card from 'widgets/Card/Card';
import Rating from 'widgets/Rating/Rating';

const SingleReview = ({ review, Controls, ...passProps }) => (
  <>
    <Card
      key={review.reviewId}
      className={classNames(
        'bop-reviews__review',
        { 'bop-reviews__review--withResponse': review.response })
      }
    >
      <div
        className="bop-reviews__rating"
        itemProp="review"
        itemScope=""
        itemType="http://schema.org/Review"
      >
        <Rating
          medium
          withoutTitle
          reviewStats={{ averageRate: review.rating }}
        />
        <span className="gn-content__caption bop-reviews__caption">
          <meta
            itemProp="datePublished"
            content={format(review.creationDate, 'DD MMMM YYYY')}
          />{format(review.creationDate, 'DD MMMM YYYY')} by&nbsp;
          <Link
            itemProp="author"
            itemScope=""
            itemType="http://schema.org/Person"
            to={`/webshop/readAllCustomerReviews.do?cn=${review.customerNumber}`}
            className="bop-reviews__nickname"
          >
            {review.customerNickname}
          </Link>
        </span>
      </div>
      {review.title && <h6 className="bop-reviews__title">{review.title}</h6>}
      {review.text && <p>{review.text}</p>}
      {Controls && <Controls review={review} {...passProps} />}
    </Card>
    {review.response && <ReviewResponse response={review.response} />}
  </>
);

SingleReview.propTypes = {
  review: PropTypes.object.isRequired,
  Controls: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
};

export default SingleReview;
